export default {
  "user.submit": "确认",
  "user.name.error": "请输⼊正确的手机号码（仅限中国大陆）或邮箱",
  "user.pwd.error": "请输⼊6-16位密码",
  "user.pwd.inlegal.error": "含有非法字符",
  "user.confirm.pwd.error": "两次输入的密码不同",
  "user.code.error": "请输⼊6位数验证码",
  "user.agreement.error": "请先阅读并同意小库注册用户协议和用户隐私协议",

  "user.login.welcome1": "你好",
  "user.login.welcome2": "请登录",
  "user.login.new": "还没有账号 点击注册",
  "user.login.wx": "一键微信登录",
  "user.login.name.placeholder": "输入手机号或邮箱",
  "user.login.pwd.placeholder": "输入密码",
  "user.login.forget.pwd": "忘记密码",
  "user.login": "立即登录",
  "user.login.account": "账号密码登录",

  "user.login.code": "验证码登录",
  "user.login.code.send": "获取验证码",
  "user.login.code.send.ok": "已发送验证码",
  "user.login.code.second": "秒",
  "user.login.code.placeholder": "输入6位验证码",

  "user.register": "欢迎注册",
  "user.register.pwd.placeholder": "请输入6-16位密码",
  "user.register.agreement.txt1": "我已阅读并同意小库",
  "user.register.agreement.txt2": "和",
  "user.register.agreement.user": "注册用户协议",
  "user.register.agreement.privacy": "用户隐私协议",
  "user.register.submit": "立即注册",
  "user.register.login": "已有账号 , 立即登录",

  "user.act.suctxt1": "使用PC设备访问，免费体验设计云全功能",
  "user.act.suctxt2": "建议使用谷歌浏览器",
  "user.act.url": "www.xkool.ai",
  "user.act.visit": "查看智能规划示例项目",

  "user.bind.visit": "微信绑定",
  "user.bind.connect": "绑定",
  "user.bind.submit": "绑定",
  "user.bind.login": "返回登录",

  "user.reset.pwd": "重设密码",
  "user.reset.pwd.new.placehoolder": "输入新的密码",
  "user.reset.pwd.confirm.placehoolder": "再次输入新的密码",
  "user.reset.pwd.ok": "确认",
  "user.reset.pwd.login": "返回登录",
  "user.reset.pwd.succuess": "返回密码修改成功，请重新登录登录",
};
